export default __webpack_public_path__ + "b511e5516ec82cdd7192c72786138dd8.png";